"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROMPT_LAB_MAX_RUN_COUNT = exports.PROMPT_LAB_DEFAULT_RUN_COUNT = exports.PROMPT_LAB_DEFAULT_TAG = exports.PROMPT_LAB_STAGES = void 0;
// Order must match the pipeline: the hypothesis is generated before persona
// ranking, so replaying from a stage re-runs exactly that stage onward.
exports.PROMPT_LAB_STAGES = [
    'hypothesis',
    'persona-ranking',
    'layout-reference-ranking',
    'product-content',
    'generation',
];
exports.PROMPT_LAB_DEFAULT_TAG = 'candidate';
exports.PROMPT_LAB_DEFAULT_RUN_COUNT = 5;
exports.PROMPT_LAB_MAX_RUN_COUNT = 10;
